<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="text-muted">
                    <b>Laboratory Guidelines</b>
                </span>
            </b-card-header>
            <b-card-body>
                <b-table 
                    :fields="columns"
                    :items="formatLabGuidelines(results)"
                    bordered
                />
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import { recommendation_elements } from '@/shared/result-table-fields';
import ReportResultFormat from "@/components/shared/mixins/ReportResultFormat";
import ResultModel from "@/models/modus/ResultModel";

export default {
    name: "LaboratoryGuidelines",
    components: {},
    props: {
        results: {
            type: Object,
            default: () => new ResultModel()
        }
    },
    mixins: [ ReportResultFormat ],
    computed: {
        columns() {
            return [
                "crop",
                { key: "crop_yield", label: "yield"},
                "units",
                ...recommendation_elements.map(item => {
                    return {
                        key: item.element,
                        lable: `${item.element} ${item.unit}`
                    }
                })
            ];
        }
    },
};
</script>